import { __makeTemplateObject } from "tslib";
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { font, spacing, border } from '@metro-ui/tokens/js';
var fontSizeMap = {
    small: font.text.small,
    medium: font.text.medium,
    large: font.text.medium,
};
var paddingMap = {
    small: spacing['xx-small'] + " " + spacing['x-small'],
    medium: "calc(" + spacing['x-small'] + " - " + border.width.medium + ") " + spacing['x-small'],
    large: "calc(" + spacing.medium + " - " + border.width.medium + ") " + spacing['x-small'],
};
export var Content = styled.div(function (_a) {
    var size = _a.size, isOverarching = _a.isOverarching;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    font-size: ", ";\n    line-height: ", ";\n    padding: ", ";\n\n    display: flex;\n    flex: 1 1 auto;\n    flex-wrap: wrap;\n\n    & > *:not(:last-child) {\n      margin-right: ", ";\n    }\n\n    ", "\n  "], ["\n    position: relative;\n    font-size: ", ";\n    line-height: ", ";\n    padding: ", ";\n\n    display: flex;\n    flex: 1 1 auto;\n    flex-wrap: wrap;\n\n    & > *:not(:last-child) {\n      margin-right: ", ";\n    }\n\n    ", "\n  "])), fontSizeMap[size].size, fontSizeMap[size]['line-height'], paddingMap[size], spacing['x-small'], isOverarching && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        padding-left: 0;\n      "], ["\n        padding-left: 0;\n      "]))));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=Content.js.map